import React from 'react';
import {Formik, Field, Form} from 'formik'
import {
  Checkbox,
  FormActions,
  TextArea,
  handleErrors
} from '@/components/form'
import {useListView} from '@/components/table/core/ListViewProvider'
import {useQueryResponse} from '@/components/table/core/QueryResponseProvider'
import { SupportTicket } from '../../core/_models';
import { replyTicket } from '../../core/_requests';


export const ReplyForm = () => {
  const {itemForUpdate, setItemForUpdate, setAction} = useListView()

  const {refetch} = useQueryResponse()
  const ticket = itemForUpdate as SupportTicket
  const close = () => {
    setAction(undefined)
    setItemForUpdate(undefined)
  }

  return (
    <Formik
      initialValues={{
        closed: false,
        message: ''
      }}
      onSubmit={async (values, {setErrors}) => {
        try {
          await replyTicket(ticket._id, values.message, values.closed)
          close()
          refetch()
        } catch (e: unknown) {
          handleErrors(e, setErrors)
        }
      }}
    >
      {() => (
        <Form id="product-availability" className='form'>
          <Field
            id="closed"
            name="closed"
            component={Checkbox}
            label="Close ticket"
            defaultChecked={false}
          />

          <Field
            name="message"
            type="text"
            component={TextArea}
            rows={5}
            label="Message"
            required={false}
          />
          <Field
            component={FormActions}
            close={close}
          />
        </Form>
      )}
    </Formik>
  );
}
